
const SET_SAID_TOKEN = 'serviceRequestQuery/SET_SAID';
const GET_SAID_TOKEN = 'serviceRequestQuery/GET_SAID';
export default {
    SET_SAID_TOKEN,
    GET_SAID_TOKEN
}